
















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BaseLink from '@/components/common/BaseLink.vue'
import BaseLanguageSwitcher from '@/components/common/BaseLanguageSwitcher.vue'

@Component( {
    components: {
        'oe-link': BaseLink,
        'oe-language-switcher': BaseLanguageSwitcher
    },
    computed: mapGetters( {
        currentUser: 'usersModule/currentUser'
    } )
} )
export default class ApplicationHeader extends Vue {
    mobileActive = false

    toggleMobileNav() {
        this.mobileActive = !this.mobileActive
        this.$store.commit( 'globalModule/setBodyFixed' )
    }

    logoutUser( event: Event ) {
        event.preventDefault()

        this.$store.dispatch( 'usersModule/logoutCurrentUser' )
            .then( () => this.$router.push( `/${this.$i18n.locale}/login` ) )
            .catch( error => console.error( error ) )
    }

    @Watch( '$route' )
    setMobileNav( to: any, from: any ) {
        if ( this.mobileActive ) {
            this.mobileActive = false
        }
    }
}
